<template>
  <div class="product">
    <div class="title">
      <el-breadcrumb>
        <el-breadcrumb-item :to="{ path: '/home/monitor' }">{{type=='product'?'产品检测':type=='sku'?'sku检测':'店铺授权'}}</el-breadcrumb-item>
        <el-breadcrumb-item v-if="type=='product'"
                            :to="{ path: `/home/productMonitor/${type}/${$route.params.pid}` }">{{testname}}检测方案</el-breadcrumb-item>
        <el-breadcrumb-item>{{testname}}检测方案</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="main">
      <el-card>
        <el-row :gutter="80"
                class="dataTop">
          <el-col :span="12">
            <div class="subtitle">
              <h4>{{testname}}</h4>
            </div>
            <el-row :gutter="40">
              <el-col :span="12">
                <ul class="list"
                    v-if="type == 'product'">
                  <li>
                    <p style="word-break: break-all; ">产品名称：{{ list.name || "-" }}</p>
                  </li>
                  <!-- <li><p>规格：250ml</p></li> -->
                  <li>
                    <p>SKUID：{{ list.sku_id || "-" }}</p>
                  </li>
                  <li>
                    <p>政府价格：{{ list.price_gov + " 元" || "-" }}</p>
                  </li>
                  <li>
                    <p>上限价格：{{ list.price_top + " 元" || "-" }}</p>
                  </li>
                  <li>
                    <p>下限价格：{{ list.price_bottom + " 元" || "-" }}</p>
                  </li>
                  <li>
                    <p>指导价格：{{ list.price_guiding + " 元" || "-" }}</p>
                  </li>
                </ul>
                <ul class="list"
                    v-if="type == 'shop'">
                  <li>
                    <p>店铺名称：{{ testname || "-" }}</p>
                  </li>
                  <li>
                    <p>联系电话：{{ list.phone || "-" }}</p>
                  </li>
                  <li>
                    <p>联系地址：{{ list.addrss || "-" }}</p>
                  </li>
                </ul>
              </el-col>
              <el-col :span="12"
                      class="iboxs">
                <div class="ibox">
                  <p>最近低价sku总数</p>
                  <h4>{{ count }}</h4>
                  <span>条</span>
                </div>
                <div class="ibox">
                  <p>最新低价sku占比</p>
                  <h4 class="red">{{ percentage }}</h4>
                  <span>百分比</span>
                </div>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="12"
                  v-if="type == 'sku'">
            <div class="subtitle">
              <h4>最新各渠道低价商品sku分布图</h4>
              <!-- //  <p>最近更新时间：{{ date || "-" }}</p> -->
            </div>
            <div id="chartPie"
                 style="width: 100%; height: 300px; border: 1px solid #ddd"></div>
          </el-col>
          <el-col :span="12"
                  v-else>
            <div class="subtitle">
              <h4>最近7天低价商品数量波动趋势</h4>
              <p>最近更新时间：{{ date || "-" }}</p>
            </div>
            <div id="EChart"
                 style="width: 100%; height: 300px; border: 1px solid #ddd"></div>
          </el-col>
        </el-row>

        <div class="form"
             v-show="type == 'product'">
          <el-form v-model="formInline"
                   inline
                   class="formInline">
            <div>
              <el-form-item label="授权类型：">
                <el-select v-model="formInline.type"
                           placeholder="请选择授权类型"
                           clearable>
                  <el-option label="授权"
                             value="1"> </el-option>
                  <el-option label="未授权"
                             value="2"> </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="平台：">
                <el-select v-model="formInline.platform"
                           placeholder="请选择平台"
                           clearable>
                  <el-option v-for="item in options"
                             :key="item.id"
                             :label="item.name"
                             :value="item.id"> </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="关键字：">
                <el-input v-model="formInline.keyword"
                          placeholder="请输入关键字"
                          clearable></el-input>
              </el-form-item>
            </div>
            <div>
              <el-form-item>
                <el-button @click="reset">重 置</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="primary"
                           @click="getTableList(1)">查 询</el-button>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div class="table">
          <el-table :data="tableData"
                    style="width: 100%"
                    v-loading='loading'
                    border>
            <el-table-column align="center"
                             prop="id"
                             label="ID"
                             width="55"> </el-table-column>
            <el-table-column align="center"
                             prop="name"
                             label="产品名称"
                             width="140"
                             show-overflow-tooltip
                             v-if="type == 'shop'||type == 'sku'"> </el-table-column>
            <el-table-column align="center"
                             prop="shop_name"
                             label="店铺名称"
                             width="140"
                             show-overflow-tooltip
                             v-if="type == 'sku'"> </el-table-column>
            <el-table-column align="center"
                             prop="name"
                             label="SKU名称"
                             width="140"
                             show-overflow-tooltip
                             v-if="type == 'product'"> </el-table-column>
            <el-table-column align="center"
                             prop="shop_is_auth"
                             label="是否授权"
                             width="140">
              <template slot-scope="{ row }">
                {{ row.is_auth == 1 ? "已授权" : "未授权" }}
              </template>
            </el-table-column>
            <el-table-column align="center"
                             width="140"
                             prop="platform_name"
                             label="平台">
            </el-table-column>
            <el-table-column align="center"
                             width="140"
                             prop="sell_price"
                             sortable
                             label="页面价格"> </el-table-column>
            <el-table-column align="center"
                             width="140"
                             prop="final_price"
                             sortable
                             label="折后价格"> </el-table-column>
            <el-table-column align="center"
                             width="140"
                             prop="left_price"
                             sortable
                             label="差价"> </el-table-column>
            <el-table-column align="center"
                             width="140"
                             prop="console_price"
                             sortable
                             label="监测价格"> </el-table-column>
            <el-table-column align="center"
                             width="140"
                             prop="take_part_in"
                             label="破价原因">
              <template slot-scope="{ row }">
                <div v-if="row.warning_type==2">
                  <span v-for="(item,index) in row.take_part_in.split(',')"
                        :key="index">
                    {{ item == 1 ? "秒杀活动" : item == 2 ? "plus会员" : item == 3 ? "品牌闪购" :item == 4 ? "满减卷" :item == 5 ? "促销满减" :item == 6 ? "满折":item == 7 ? "满赠":item == 8 ? "预售":"赠品" }}
                  </span>
                </div>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column align="center"
                             width="140"
                             prop="create_time"
                             label="更新时间"> </el-table-column>
            <el-table-column align="center"
                             width="140"
                             prop="warning_type"
                             label="价格预警">
              <template slot-scope="{ row }">
                <span style="color:red"> {{ row.warning_type == 1 ? "价格上限" : row.warning_type == 2 ? "价格下限" : "政府价格上限" }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center"
                             width="140"
                             label="操作"
                             fixed="right">
              <template slot-scope="{ row }">
                <div class="link">
                  <el-link type="primary"
                           @click="RecordDetail(row)">详情</el-link>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pageSize">
          <el-pagination background
                         @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"
                         :current-page="page"
                         :page-sizes="[10, 20, 30, 40]"
                         :page-size="size"
                         layout="total, sizes, prev, pager, next, jumper"
                         :total="total">
          </el-pagination>
        </div>
      </el-card>
    </div>
    <div v-if="closeModelView">
      <Record @closeModel="initModel"
              :url='url'
              :plaid='plaid'
              :pid='pid'></Record>

    </div>

  </div>
</template>

<script>
const echarts = require("echarts");
import Record from "@/components/Modules/Monitor/Record.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  data () {
    return {
      formInline: {
        type: "",
        platform: "",
        keyword: "",
      },
      closeModelView: false,
      loading: false,
      tableData: [],
      total: 0,
      page: 1,
      size: 10,
      options: [],
      type: "",
      count: "0",
      percentage: "0%",
      list: [],
      date: "",
      price_opt: [],
      x: [],
      y: [],
      url: '',
      pid: '',
      plaid: '',
      testname: sessionStorage.getItem('testname')
    };
  },
  /*   */
  components: {
    Record,
  },
  computed: {
    ...mapGetters({
      getToken: "getToken",
    }),
  },
  async mounted () {

    this.type = this.$route.params.type;
    await this.getTableList()
    await this.getPlatform()
    this.getSkuChart()
    if (this.type == "product") {
      this.getListDetail();
      this.getproductShopDetailsChart()
    } else if (this.type == "shop") {
      //  this.getListDetail();
      this.getShopChart();
    } else {
      this.getchartPieAPI()
    }

  },
  methods: {
    initModel () {
      this.closeModelView = false
    },
    ...mapActions({
      shopList: "detect/shopList",
      platformSelect: "detect/platformSelect", //平台列表
      skuChart: "detect/skuChart", //平台列表
      consoleplanDetailList: "detect/consoleplanDetailList",
      productShopChart: "detect/productShopChart",
      productShopDetailsChart: "detect/productShopDetailsChart",
      chartPieAPI: "detect/chartPieAPI",
      productDetailList: "detect/productDetailList",
      productDetailchartd: "detect/productDetailchartd",
    }),
    insertStr (soure, start, newStr) {
      return soure.slice(0, start) + newStr + soure.slice(start);
    },
    getShopChart () {
      let params = {
        token: this.getToken,
        shop_id: this.$route.params.id,
      };
      this.productShopChart(params).then(({ data }) => {
        console.log(data, 'data')
        if (data.code == 1) {
          this.date = data.data[data.data.length - 1].date ? data.data[data.data.length - 1].date : ''

          this.x = data.data.map((item) => item.date);
          data.data.forEach((item) => {
            this.y.push(item.list[0].result)


          }

          );
          console.log(this.y, ' this.y --')
          this.getRenderer();
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    getproductShopDetailsChart () {
      console.log(this.$route.params.pid, ';', this.$route.params.id)
      let params = {
        token: this.getToken,
        console_plan_id: this.$route.params.pid,
        console_product_id: this.$route.params.id,
      };

      this.productShopDetailsChart(params).then(({ data }) => {
        if (data.code == 1) {
          console.log(data, 'data---5')
          this.date = data.data[data.data.length - 1].date || "";
          /*   this.x = data.data[0].list.map((item) => item.number);
            this.y = data.data[0].list.map((item) => item.result); */
          this.x = data.data.map((item) => item.date);
          data.data.forEach((item) => {
            this.y.push(item.list[0].result)
     })
          this.getRenderer();
          /*   if (data.data.list.length > 0) {
                data.data.list.forEach(el => {
                  this.x.push(parseInt(el.code))
                  if (this.x.length > 1) {
                    el.list.forEach(elt => {
                      this.y.push(parseInt(elt.result))
                    })
                  } else {
                    this.y.push(parseInt(el.data[el.data.length - 1].result))
                  }
                }); 
                if (this.x.length > 0 && this.y.length > 0) {
                  this.$nextTick(() => {
                    this.getRenderer(this.x, this.y)
                  })
                }
              } */
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    getchartPieAPI () {
      let params = {
        token: this.getToken,
        plan_id: this.$route.params.id, //方案id  必填
        type: 2,
      }
      this.chartPieAPI(params).then(({ data }) => {
        if (data.code == 1) {
          let typeArr = []
          let dataList = []
          if (data.data.length > 0) {
            dataList = data.data
            data.data.forEach(el => {
              typeArr.push(el.name)
            })
            this.$nextTick(() => {
              this.drawPieChart(typeArr, dataList);
            })
          }

        } else {
          this.$message.error(data.msg);
        }
      });
    },

    getListDetail () {
      this.load = true;
      let params = {
        token: this.getToken,
        plan_id: this.$route.params.pid, //方案id  必填
        id: this.$route.params.id,
      };
      this.consoleplanDetailList(params).then(({ data }) => {
        this.load = false;
        if (data.code == 1) {

          this.list = data.data.list[0];
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    reset () {
      this.formInline = {
        type: "",
        platform: "",
        keyword: "",
      };
      this.getTableList()
    },
    getSkuChart () {
      let params = {
        token: this.getToken,
        type: this.$route.params.type == "product" ? 1 : this.$route.params.type == "sku" ? 2 : 3,
        plan_id: this.$route.params.pid,
        product_id: this.$route.params.id,
      };
      this.skuChart(params).then(({ data }) => {
        if (data.code == 1) {
          this.count = data.data.count;
          this.percentage = data.data.percentage;

        }
      });
    },
    getPlatform () {
      let params = {
        token: this.getToken,
      };
      this.platformSelect(params).then(({ data }) => {
        if (data.code == 1) {
          this.options = data.data;
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    getTableList () {
      this.loading = true
      try {
        let params, url;
        switch (this.type) {
          case "shop":
            params = {
              token: this.getToken,
              console_type: 3,
              console_plan_id: this.$route.params.id,
              page: this.page,
              size: this.size,
              is_auth: this.formInline.type, // 1 授权，2未授权
              platform_id: this.formInline.platform  // 平台ID
            };
            /* formInline.keyword */
            url = this.shopList;
            break;
          case "product":
            params = {
              token: this.getToken,
              console_type: 1,
              console_plan_id: this.$route.params.pid,
              console_product_id: this.$route.params.id,
              keywords: this.formInline.keyword,
              page: this.page,
              size: this.size,
              is_auth: this.formInline.type, // 1 授权，2未授权
              platform_id: this.formInline.platform  // 平台ID
            };
            url = this.shopList;
            break;
          case "sku":
            params = {
              token: this.getToken,
              console_type: 2,
              console_plan_id: this.$route.params.id,
              page: this.page,
              size: this.size,
              is_auth: this.formInline.type, // 1 授权，2未授权
              platform_id: this.formInline.platform  // 平台ID
            };
            url = this.shopList;
            break;
          default:
            break;
        }
        url(params).then(({ data }) => {
          this.loading = false
          if (data.code == 1) {
            if (this.type == "shop") {
              this.tableData = data.data.data.list;
              this.total = data.data.data.count;
              // if (this.tableData.length > 0) {
              // this.tableData.forEach((item) => {
              //     item.platform = this.options.find((v) => item.platform_id == v.id).name || "-";
              // });
              // }
            } else if (this.type == "product") {
              this.tableData = data.data.data.list;
              this.total = data.data.data.count;
            } else {

              this.tableData = data.data.data.list;
              this.total = data.data.data.count;

            }
          }
        });
      } catch (err) {
        this.loading = false
        console.log(err);
      }
    },
    RecordDetail (item) {
      this.url = item.url
      this.closeModelView = true
      this.pid = item.console_product_id
      this.plaid = item.console_plan_id
      // this.$refs.refRecord.dialogVisible = true;
      // this.getproductDetailchartd()
      /*   this.$refs.refRecord.getproductDetailchartd(this.url); */
      //  this.$refs.refRecord.getRenderer();
    },
    /* 详情 */
    //productDetailList
    /*  http://192.168.0.162:4999/web/#/6/738 */
    /*  getproductDetailchartd () {
       let type = ''
       if (this.$route.params.type == "product") {
         type = 1
       } else if (this.type == "shop") {
         type = 3
       } else {
         type = 2
       }
       let par = {
         token: this.getToken,
         console_plan_id: this.$route.params.pid,
         console_type: type,
         url: this.url,
         console_product_id: this.$route.params.id,
       }
       this.productDetailchartd(par).then(data => {
         if (data.data.code == 1) {
           if (data.data.data.length > 0) {
             this.x = data.data.data.map((item) => item.number);
             this.y = data.data.data.map((item) => item.result);
            
           }
 
         } else {
           this.$message.error(data.data.msg);
         }
       })
     }, */
    getRenderer () {
      let EChart = echarts.init(document.getElementById("EChart"));
      let config = {
        tooltip: {
          show: true,
        },
        legend: {
          icon: "circle",
          itemWidth: 6,
          right: 40,
          top: 10,
          textStyle: {
            //图例文字的样式
            color: "#333",
            fontSize: 14,
          },
        },
        grid: {
          x: 60,
          y: 40,
          x2: 40,
          y2: 40,
          backgroundColor: "rgba(0,0,0,0)",
          borderWidth: 1,
          borderColor: "#ccc",
        },
        xAxis: {
          type: "category",
          data: this.x,
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            name: "京东",
            data: this.y,
            type: "line",
            smooth: true,
          },
        ],
      };
      // 设置参数
      EChart.setOption(config);
    },
    drawPieChart (arrList, datalist) {
      let mytextStyle = {
        color: "#333",
        fontSize: 18,
      };
      let mylabel = {
        show: true,
        position: "right",
        offset: [30, 40],
        formatter: '{b} : {c} ({d}%)',
        textStyle: mytextStyle
      };
      let chartPie = echarts.init(document.getElementById('chartPie'), 'macarons');
      chartPie.setOption({
        tooltip: {
          trigger: 'item',
          formatter: "{a} <br/>{b} : {c} ({d}%)",
        },
        legend: {
          icon: 'circle',
          data: arrList,
          right: "10%",

          top: "bottom",
          orient: "vertical",
        },
        series: [
          {
            name: '访问来源',
            type: 'pie',
            radius: ['50%', '70%'],
            center: ['35%', '50%'],
            data: datalist,
            animationEasing: 'cubicInOut',
            animationDuration: 2600,
            label: {
              emphasis: mylabel
            }
          }
        ]
      });
    },

    handleSizeChange (val) {
      this.size = val;
      this.getTableList();
    },
    handleCurrentChange (val) {
      this.page = val;
      this.getTableList();
    },
  },
};
</script>

<style lang="scss" scoped>
.product {
  .title {
    box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
    width: 100%;
    background: #fff;
    font-size: 20px;
    color: #000000;
    width: 100%;
    padding: 15px 32px;
  }
  ::v-deep .el-table--border th.el-table__cell {
    background-color: #f8f9fe;
  }
  .dataTop {
    margin-bottom: 40px;
  }
  .main {
    min-width: 1200px;
    margin: 20px;
    .el-card {
      min-height: 780px;
    }
    .el-col {
      .list {
        display: flex;
        flex-direction: column;
        // justify-content: space-between;
        li {
          list-style: none;
          padding-left: 14px;
          position: relative;
          margin-bottom: 22px;
          &::before {
            content: "";
            position: absolute;
            width: 6px;
            height: 6px;
            background: #409eff;
            border-radius: 50%;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
          }
          p {
            color: #333;
          }
        }
      }
      .iboxs {
        height: 300px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .ibox {
          height: 140px;
          border: 1px solid #ddd;
          padding: 20px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          color: #333;
          p {
            font-size: 18px;
          }
          h4 {
            font-size: 32px;
            font-weight: 400;
          }
          .red {
            color: #f32b2b;
          }
        }
      }
    }
    .subtitle {
      margin-bottom: 35px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      h4 {
        padding-left: 20px;
        line-height: 18px;
        position: relative;
        font-size: 16px;
        font-weight: bold;
        color: #333333;
        &::before {
          content: "";
          position: absolute;
          left: 0;
          top: 0;
          height: 100%;
          width: 2px;
          background: #2448ff;
        }
      }
      p {
        color: #666;
        font-size: 14px;
      }
    }
  }
  .pageSize {
    text-align: right;
    margin-top: 20px;
  }
  .w400 {
    width: 300px;
  }
  .link {
    a {
      margin: 0 8px;
    }
  }
  .formInline {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  ::v-deep .el-card__body {
    padding: 40px;
  }
}
</style>